import { useTranslation } from "react-i18next";
import Selector from "./Selector";

export default function LanguageSelector() {
	const { t } = useTranslation();

	return (
		<div className="relative z-11 flex justify-between items-center flex-col xs:flex-row gap-[0.1rem] xs:gap-0 w-full font-size-from-base-to-2xl">
			<p>{t("navBarItems.toolsMenu.language.title")}</p>
			<Selector />
		</div>
	);
}